export default {
  computed: {
    isIE11 () {
      return !!window.MSInputMethodContext && !!document.documentMode
    }
  }
}
